import axios from 'axios';

export const getAvailableSatelliteData = async (type, id) =>
  axios.get(`/api/data/satellite/available/v2/?${type}=${id}`);

/**
 * Examples of URLs
 * https://map.farmx.co/api/data/satellite/?ranch=73661&DataType=NDVI&date=1621422000
 * https://map.farmx.co/api/data/satellite/?block=736277&DataType=NDVI&date=1620990000
 */
export const getSatelliteDataByDataTypeAndDate = async (type, id, dataType, time) =>
  axios.get(`/api/data/satellite/?${type}=${id}&DataType=${dataType}&date=${time}`);
